/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbaording_Permission_List_Plant_ReminderInputs */

const en_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's time for your scheduled focus`)
};

const ar_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حان وقت التركيز المجدول`)
};

const de_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist Zeit für Ihren geplanten Fokus`)
};

const es_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es hora de tu sesión de concentración`)
};

const fr_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est l'heure de votre session de concentration`)
};

const it_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È il momento della tua concentrazione programmata`)
};

const ja_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定した集中時間になったとき`)
};

const ko_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계획한 집중을 시작해야 할 때`)
};

const pt_br_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora do seu foco programado`)
};

const ru_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время запланированной фокусировки`)
};

const th_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถึงเวลาสำหรับการโฟกัสที่ตั้งไว้แล้ว`)
};

const tr_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlı odaklanma zamanın geldi`)
};

const zh_cn_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你设置的提醒时间`)
};

const zh_tw_onbaording_permission_list_plant_reminder = /** @type {(inputs: Onbaording_Permission_List_Plant_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你設定的提醒時間`)
};

/**
* | output |
* | --- |
* | "It's time for your scheduled focus" |
*
* @param {Onbaording_Permission_List_Plant_ReminderInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onbaording_permission_list_plant_reminder = /** @type {((inputs?: Onbaording_Permission_List_Plant_ReminderInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbaording_Permission_List_Plant_ReminderInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "ar") return ar_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "de") return de_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "es") return es_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "fr") return fr_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "it") return it_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "ja") return ja_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "ko") return ko_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "pt_br") return pt_br_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "ru") return ru_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "th") return th_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "tr") return tr_onbaording_permission_list_plant_reminder(inputs)
	if (locale === "zh_cn") return zh_cn_onbaording_permission_list_plant_reminder(inputs)
	return zh_tw_onbaording_permission_list_plant_reminder(inputs)
});